<template>
	<v-tab-item>
		<div class="table-container mt-4">
			<v-data-table
				locale="ja-JP"
				:items="filteredQuotations"
				:headers="headers"
				:mobile-breakpoint="240"
				hide-default-footer
				disable-filtering
				disable-pagination
				disable-sort
				no-data-text="データがありません。"
			>
				<template v-slot:item="{ item }">
					<tr @click="openDialog(item.id)">
						<td>{{ item.status_i18n }}</td>
						<td>{{ item.matter.situation_i18n }}</td>
						<td>{{ item.matter.quotation_number }}</td>
						<td>{{ item.matter.team_member_name }}</td>
						<td>{{ item.matter.regular_customer_company.name }}</td>
						<td>{{ item.matter.delivery_company_name }}</td>
						<td>{{ item.matter.construction_name }}</td>
					</tr>
				</template>
			</v-data-table>
		</div>
		<QuotationShowDialog :id="selectedId" :dialog.sync="quotationDialog" />
	</v-tab-item>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import QuotationShowDialog from "../../quotation/components/QuotationShowDialog.vue"

export default {
	props: {
		isFetched: {
			type: Boolean,
		},
		q: {
			type: Object,
			default: () => ({}),
		},
	},
	components: {
		ShowDetailRecord,
		QuotationShowDialog,
	},
	data() {
		return {
			quotations: [],
			quotationDialog: false,
			selectedId: null,
			headers: [
				{
					text: "種類",
					value: "status_i18n",
					width: "100px",
				},
				{
					text: "受注確度",
					value: "matter.situation_i18n",
					width: "120px",
				},
				{
					text: "見積番号",
					value: "matter.quotation_number",
					width: "200px",
				},
				{
					text: "営業担当者",
					value: "matter.team_member_name",
					width: "120px",
				},
				{
					text: "客先名",
					value: "matter.regular_customer_company.name",
					width: "200px",
				},
				{
					text: "納入先名",
					value: "matter.delivery_company_name",
					width: "200px",
				},
				{
					text: "工事名",
					value: "matter.construction_name",
					width: "200px",
				},
			],
			common,
		}
	},
	methods: {
		fetchQuotations() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/pendings/quotations`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					// this.quotations = res.data.quotations
					const statuses = ["確認待ち", "承認待ち"]
					this.quotations = res.data.quotations.map((matter) => {
						return {
							status_i18n: statuses[[Math.floor(Math.random() * statuses.length)]],
							matter: {
								...matter,
								quotation_number: `KG70SH${String(matter.id).padStart(4, "0")}`,
								construction_name: "-",
							},
						} // レイアウト用
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openDialog(id) {
			this.selectedId = id
			this.quotationDialog = true
		},
	},
	computed: {
		filteredQuotations() {
			// this.qを使ってfilter
			return this.quotations.filter((quotation) => {
				return true
			})
		},
	},
	watch: {
		isFetched(newVal, oldVal) {
			if (oldVal == false && newVal == true) {
				this.fetchQuotations()
			} else if (oldVal == true && newVal == false) {
			}
		},
		deep: true,
	},
}
</script>
